import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  removeAccessToken,
  removeUserInfoFromLocalStorage,
  setAccessAdminToken,
  setAdminInfoFromLocalStorage,
} from "../../../shared/utils/auth";
import adminLoginApi from "../../api/admin/AdminLoginApi";

interface LoginState {
  apiToken: string;
}

interface LoginRequestDto {
  userId: string;
  userPwd: string;
  otp: string;
}

// # initial state
const initialState: LoginState = {
  apiToken: "",
};

export const trunkAdminSessionNew = createAsyncThunk(
  "sessions/admins/new",
  async () => {
    const apiToken = await adminLoginApi.adminSessionNew();
    return apiToken;
  }
);
export const trunkAdminSessionLogin = createAsyncThunk(
  "sessions/admins/login",
  async ({ userId, userPwd, otp }: LoginRequestDto) => {
    const resp = await adminLoginApi.adminSessionLogin(userId, userPwd, otp);
    return resp;
  }
);
export const trunkAdminSendOTPEMail = createAsyncThunk(
  "sessions/admins/otp/new",
  async (userId: string) => {
    const resp = await adminLoginApi.adminSendOTPEMail(userId);
    return resp;
  }
);
export const trunkAdminOTPLogin = createAsyncThunk(
  "sessions/admins/otp/login",
  async (mailOTP: string) => {
    const resp = await adminLoginApi.adminOTPLogin(mailOTP);
    return resp;
  }
);
export const trunkAdminUpdateNewPassword = createAsyncThunk(
  "papi/passwd/admin/update",
  async ({ userId, password, initOtp }: any) => {
    const resp = await adminLoginApi.adminUpdateNewPassword(
      userId,
      password,
      initOtp
    );
    return resp;
  }
);
export const trunkAdminAskSupport = createAsyncThunk(
  "admins/support",
  async (message: string) => {
    const resp = await adminLoginApi.adminAskSupport(message);
    return resp;
  }
);
const adminLoginSlice = createSlice({
  name: "adminLogin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      trunkAdminSessionLogin.fulfilled,
      (state, { payload: data }) => {
        setAccessAdminToken(data.apiToken);
        setAdminInfoFromLocalStorage(data);
        removeAccessToken();
        removeUserInfoFromLocalStorage();
      }
    );
    builder.addCase(
      trunkAdminOTPLogin.fulfilled,
      (state, { payload: data }) => {
        setAccessAdminToken(data.apiToken);
        setAdminInfoFromLocalStorage(data);
        removeAccessToken();
        removeUserInfoFromLocalStorage();
      }
    );
  },
});

export const adminLoginActions = adminLoginSlice.actions;
export default adminLoginSlice.reducer;
